var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 71.193 79.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16750",
    "data-name": "Group 16750",
    transform: "translate(-711.904 -2039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32475",
    "data-name": "Path 32475",
    d: "M34.253,2A19.253,19.253,0,1,0,53.506,21.253,19.253,19.253,0,0,0,34.253,2Z",
    transform: "translate(696.904 2037)",
    fill: "#ffd2d2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16749",
    "data-name": "Group 16749",
    transform: "translate(718.474 2044.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16748",
    "data-name": "Group 16748",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32487",
    "data-name": "Path 32487",
    d: "M164.97,173.571a1.223,1.223,0,0,0,.611,1.059l10.247,5.916a1.23,1.23,0,0,0,1.223,0L187.3,174.63a1.223,1.223,0,0,0,.611-1.059V161.739a1.23,1.23,0,0,0-.611-1.059l-10.247-5.916a1.223,1.223,0,0,0-1.223,0l-10.247,5.916a1.229,1.229,0,0,0-.611,1.059Zm2.446-9.714,7.8,4.5v9.008l-7.8-4.5Zm10.247,13.512v-9.008l7.8-4.5v9.008Zm-1.223-20.134,7.8,4.5-7.8,4.5-7.8-4.5Z",
    transform: "translate(-144.503 -130.967)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32488",
    "data-name": "Path 32488",
    d: "M236.155,25.931a1.223,1.223,0,0,0,.611-1.059V18.956a1.223,1.223,0,0,0-.611-1.059l-5.123-2.958a1.223,1.223,0,0,0-1.223,0l-4.512,2.6L211.177,9.391V4.181a1.223,1.223,0,0,0-.611-1.059L205.442.164a1.223,1.223,0,0,0-1.223,0L199.1,3.122a1.223,1.223,0,0,0-.611,1.059V10.1a1.223,1.223,0,0,0,.611,1.059l5.123,2.958a1.223,1.223,0,0,0,1.223,0l4.512-2.6,14.121,8.153v5.21a1.223,1.223,0,0,0,.611,1.059l4.512,2.6V44.841l-4.512,2.6a1.223,1.223,0,0,0-.611,1.059v5.21l-10.1,5.832a1.223,1.223,0,1,0,1.223,2.118l10.1-5.832,4.512,2.6a1.223,1.223,0,0,0,1.223,0l5.123-2.958a1.223,1.223,0,0,0,.611-1.059V48.5a1.223,1.223,0,0,0-.611-1.059l-4.512-2.6V28.536ZM208.731,9.391l-3.9,2.252-3.9-2.252v-4.5l3.9-2.252,3.9,2.252v4.5ZM226.52,19.662l3.9-2.252,3.9,2.252v4.5l-3.9,2.252-3.9-2.252Zm7.8,34.053-3.9,2.252-3.9-2.252v-4.5l3.9-2.252,3.9,2.252Z",
    transform: "translate(-172.894 0)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32489",
    "data-name": "Path 32489",
    d: "M68.753,127.788,63.63,124.83a1.223,1.223,0,0,0-1.223,0l-4.512,2.6-14.121-8.152v-5.21a1.223,1.223,0,0,0-.611-1.059l-4.512-2.6V94.1l4.512-2.6a1.223,1.223,0,0,0,.611-1.059v-5.21l9.609-5.548a1.223,1.223,0,1,0-1.223-2.118l-9.609,5.548L38.04,80.506a1.223,1.223,0,0,0-1.223,0l-5.123,2.958a1.223,1.223,0,0,0-.611,1.059v5.916a1.223,1.223,0,0,0,.611,1.059l4.512,2.6v16.305l-4.512,2.6a1.223,1.223,0,0,0-.611,1.059v5.916a1.223,1.223,0,0,0,.611,1.059l5.123,2.958a1.223,1.223,0,0,0,1.223,0l4.512-2.6,14.121,8.153v5.21a1.223,1.223,0,0,0,.611,1.059l5.123,2.958a1.223,1.223,0,0,0,1.223,0l5.123-2.958a1.223,1.223,0,0,0,.611-1.059v-5.916A1.223,1.223,0,0,0,68.753,127.788ZM33.528,85.229l3.9-2.252,3.9,2.252v4.5l-3.9,2.252-3.9-2.252Zm7.8,34.053-3.9,2.252-3.9-2.252v-4.5l3.9-2.252,3.9,2.252Zm25.59,14.775-3.9,2.252-3.9-2.252v-4.5l3.9-2.252,3.9,2.252v4.5Z",
    transform: "translate(-31.082 -65.568)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureToken);
export default __webpack_public_path__ + "static/media/SecureToken.c9af628e71bb618db82ce72213dd7c94.svg";
export { ForwardRef as ReactComponent };